/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


export const EDGECLOUDORG = 'edgecloudorg'
export const STATUS_UNDER_MAINTAINANCE = 999
export const BOOLEAN = 'boolean'

export const RESPONSE_STATUS_EXPIRED = 401
export const RESPONSE_STATUS_SUCCESS = 200

export const COLOR_GREEN = '#388E3C'
export const COLOR_RED = '#ab2424'

export const LS_THASH = '8600b1cdcdf58f43ee8a2152433448fa'
export const LS_USER_META_DATA = 'usermetadata'
export const LS_LINE_GRAPH_FULL_SCREEN = 'LineGraphFullScreen'
export const LS_NOTIFICATION = 'Notification'

export const ACTION_LABEL = 'ActionLabel'
export const ACTION_WARNING = 'ActionWarning'
export const ACTION_DISABLE = 'ActionDisable'
export const ACTION_VISIBLE = 'ActionVisible'
export const ACTION_POOL_ACCESS_DEVELOPER = 'PoolAccess'
export const ACTION_POOL_ACCESS_DEVELOPER_REJECT = 'Reject'
export const ACTION_POOL_ACCESS_ADMIN_CONFIRM = 'AdminConfirm'
export const ACTION_POOL_ACCESS_ADMIN_REMOVE = 'AdminRemove'
export const ACTION_AUDIT = 'ACTION_AUDIT'
export const ACTION_ADD_USER = 'ACTION_ADD_USER'
export const ACTION_EDGE_BOX_ENABLE = 'ACTION_EDGE_BOX_ENABLE'
export const ACTION_UPDATE = 'Update'
export const ACTION_DELETE = 'Delete'
export const ACTION_CLONE = 'Clone'
export const UPDATE_BUILD = 'UpdateBuild'
export const ACTION_DME_METRICS = 'DMEMetrics'
export const ACTION_REQUEST_LATENCY = 'RequestLatency'
export const ACTION_TERMINAL = 'Terminal'
export const ACTION_POWER_ON = 'Power On'
export const ACTION_POWER_OFF = 'Power Off'
export const ACTION_REBOOT = 'Reboot'
export const ACTION_REFRESH = 'Refresh'
export const ACTION_UPGRADE = 'Upgrade'
export const ACTION_BILLING_ADD_CHILD = 'AddChild'
export const ACTION_BILLING_REMOVE_CHILD = 'RemovedChild'
export const ACTION_MANIFEST = 'Show Manifest'
export const ACTION_LATENCY_METRICS = 'LatencyMetrics'
export const ACTION_TRACK_DEVICES = 'TrackDevices'
export const ACTION_SHOW_NODE = 'ShowNode'
export const ACTION_ADD_ALLIANCE_ORG = 'AddAllianceOrg'
export const ACTION_REMOVE_ALLIANCE_ORG = 'RemoveAllianceOrg'
export const ACTION_SHARE_ZONES = 'ShareZones'
export const ACTION_UNSHARE_ZONES = 'UnShareZones'
export const ACTION_UPDATE_PARTNER = 'updatePartner'
export const ACTION_SET_API_KEY = 'setAPIKey'
export const ACTION_REGISTER_FEDERATION = 'RegisterFederation'
export const ACTION_DEREGISTER_FEDERATION = 'DeRegisterFederation'
export const ACTION_GENERATE_API_KEY = 'GenerateApiKey'
export const ACTION_DEREGISTER_ZONES = 'DeregisterFederationZones'
export const ACTION_REGISTER_ZONES = 'registerFederationZones'
export const ACTION_HOST_DELETE = 'federationFederatorDelete'
export const ACTION_HOST_ZONE_BASE_DELETE = 'federationZoneBaseDelete'

export const AUTOCLUSTER = 'autocluster'
export const CLOUDLET_COMPAT_VERSION_2_4 = 0
export const CLOUDLET_COMPAT_VERSION_2_4_1 = 1

export const DEPLOYMENT_TYPE_DOCKER = 'docker';
export const DEPLOYMENT_TYPE_KUBERNETES = 'kubernetes';
export const DEPLOYMENT_TYPE_VM = 'vm';
export const DEPLOYMENT_TYPE_HELM = 'helm';

export const ACCESS_TYPE_DEFAULT_FOR_DEPLOYMENT = 'Default For Deployment';
export const ACCESS_TYPE_DIRECT = 'Direct';
export const ACCESS_TYPE_LOAD_BALANCER = 'Load Balancer';

export const IMAGE_TYPE_DOCKER = 'Docker';
export const IMAGE_TYPE_QCOW = 'Qcow';
export const IMAGE_TYPE_HELM = 'Helm';

export const IP_ACCESS_DEDICATED = 'Dedicated';
export const IP_ACCESS_SHARED = 'Shared';

export const UNKNOWN = 'Unknown'
export const ADD = 'Add'
export const UPDATE = 'Update'
export const TYPE_JSON = 'JSON'
export const TYPE_STRING = 'String'
export const TYPE_YAML = 'YAML'
export const TYPE_ARRAY = 'Array'
export const TYPE_DATE = 'DATE'
export const TYPE_URL = 'URL'
export const ADD_CLOUDLET = 'AddCloudlet'
export const DELETE_CLOUDLET = 'DeleteCloudlet'
export const ADD_ORGANIZATION = 'AddOrganization'
export const DELETE_ORGANIZATION = 'DeleteOrganization'

export const RECEIVER_TYPE_EMAIL = 'Email'
export const RECEIVER_TYPE_SLACK = 'Slack'
export const RECEIVER_TYPE_PAGER_DUTY = 'PagerDuty'

export const DELETE = 'Delete'
export const SELECT = 'Select'
export const CLOUDLET = 'Cloudlet'
export const CLUSTER_INST = 'ClusterInst'
export const APP_INST = 'AppInst'
export const IP_SUPPORT_STATIC = 'Static'
export const IP_SUPPORT_DYNAMIC = 'Dynamic'
export const YES = 'Yes'
export const NO = 'No'
export const RUN_COMMAND = 'Run Command';
export const SHOW_LOGS = 'Show Logs';
export const REGISTER = 'Register'
export const DE_REGISTER = 'De Register'

export const PLATFORM_TYPE_OPEN_STACK = 'openstack'
export const PLATFORM_TYPE_VMPOOL = 'vmpool'
export const PLATFORM_TYPE_VCD = 'vcd'
export const PLATFORM_TYPE_K8S_BARE_METAL = 'k8sbaremetal'
export const PLATFORM_TYPE_FEDERATION = 'federation'

export const MAINTENANCE_STATE_NORMAL_OPERATION = 'Normal Operation'
export const MAINTENANCE_STATE_MAINTENANCE_START = 'Maintenance Start'
export const MAINTENANCE_STATE_FAILOVER_REQUESTED = 'Failover Requested'
export const MAINTENANCE_STATE_FAILOVER_DONE = 'Failover Done'
export const MAINTENANCE_STATE_FAILOVER_ERROR = 'Failover Error'
export const MAINTENANCE_STATE_MAINTENANCE_START_NO_FAILOVER = 'Maintenance Start No Failover'
export const MAINTENANCE_STATE_CRM_REQUESTED = 'CRM Requested'
export const MAINTENANCE_STATE_CRM_UNDER_MAINTENANCE = 'CRM Under Maintenance'
export const MAINTENANCE_STATE_CRM_ERROR = 'CRM Error'
export const MAINTENANCE_STATE_UNDER_MAINTENANCE = 'Under Maintenance'

export const INFRA_API_ACCESS_DIRECT = 'Direct'
export const INFRA_API_ACCESS_RESTRICTED = 'Restricted'

export const LIVENESS_STATIC = 'Static'
export const LIVENESS_DYNAMIC = 'Dynamic'
export const LIVENESS_AUTOPROV = 'Auto Prov'

export const ALL = 'ALL'
export const ADMIN = 'admin'
export const OPERATOR = 'operator'
export const DEVELOPER = 'developer'
export const VIEWER = 'Viewer'
export const ADMIN_MANAGER = 'AdminManager'
export const ADMIN_CONTRIBUTOR = 'AdminContributor'
export const ADMIN_VIEWER = 'AdminViewer'
export const OPERATOR_MANAGER = 'OperatorManager'
export const OPERATOR_CONTRIBUTOR = 'OperatorContributor'
export const OPERATOR_VIEWER = 'OperatorViewer'
export const DEVELOPER_MANAGER = 'DeveloperManager'
export const DEVELOPER_CONTRIBUTOR = 'DeveloperContributor'
export const DEVELOPER_VIEWER = 'DeveloperViewer'

export const CONFIG_ENV_VAR = 'Environment Variables Yaml'
export const CONFIG_HELM_CUST = 'Helm Customization Yaml'

export const CRM_OVERRIDE_NO_OVERRIDE = 0
export const CRM_OVERRIDE_IGNORE_CRM_ERRORS = 1
export const CRM_OVERRIDE_IGNORE_CRM = 2
export const CRM_OVERRIDE_IGNORE_TRANSIENT_STATE = 3
export const CRM_OVERRIDE_IGNORE_CRM_AND_TRANSIENT_STATE = 4

export const POWER_STATE_POWER_ON_REQUESTED = 'Power On Requested'
export const POWER_STATE_POWERING_ON = 'Powering On'
export const POWER_STATE_POWER_ON = 'Power On'
export const POWER_STATE_POWER_OFF_REQUESTED = 'Power Off Requested'
export const POWER_STATE_POWERING_OFF = 'Powering Off'
export const POWER_STATE_POWER_OFF = 'Power Off'
export const POWER_STATE_REBOOT_REQUESTED = 'Reboot Requested'
export const POWER_STATE_REBOOTING = 'Rebooting'
export const POWER_STATE_REBOOT = 'Reboot'
export const POWER_STATE_ERROR = 'Error'

export const HEALTH_CHECK = 'HEALTH_CHECK'
export const HEALTH_CHECK_FAIL_ROOTLB_OFFLINE = 'Rootlb Offline'
export const HEALTH_CHECK_FAIL_SERVER_FAIL = 'Server Fail'
export const HEALTH_CHECK_OK = 'OK'
export const HEALTH_CLOUDLET_OFFLINE = 'Cloudlet Offline'

export const OFFLINE = 'Offline'
export const ONLINE = 'Online'

export const PAGE_DASHBOARD = 'Dashboard'
export const PAGE_ORGANIZATIONS = 'Organizations'
export const PAGE_USER_ROLES = 'UserRoles'
export const PAGE_ACCOUNTS = 'Accounts'
export const PAGE_CONFIG = 'Config'
export const PAGE_CLOUDLETS = 'Cloudlets'
export const PAGE_CLOUDLET_POOLS = 'CloudletPools'
export const PAGE_POOL_ACCESS = 'PoolAccess'
export const PAGE_FLAVORS = 'Flavors'
export const PAGE_CLUSTER_INSTANCES = 'ClusterInstances'
export const PAGE_APPS = 'Apps'
export const PAGE_APP_INSTANCES = 'AppInstances'
export const PAGE_POLICIES = 'Policies'
export const PAGE_AUTO_PROVISIONING_POLICY = 'AutoProvisioningPolicy'
export const PAGE_TRUST_POLICY = 'TrustPolicy'
export const PAGE_AUTO_SCALE_POLICY = 'AutoScalePolicy'
export const PAGE_MONITORING = 'Monitoring'
export const PAGE_MONITORING_RELOAD = 'Reload'
export const PAGE_ALERTS = 'AlertReceivers'
export const PAGE_BILLING_ORG = 'BillingOrg'
export const PAGE_INVOICES = 'Invoices'
export const PAGE_REPORTER = 'Reporter'
export const PAGE_ALERT_POLICY = 'AlertPolicy'
export const PAGE_GPU_DRIVER = 'GPU Driver'

export const OS_UNKNOWN = UNKNOWN
export const OS_LINUX = 'Linux'
export const OS_WINDOWS = 'Windows'
export const OS_OTHERS = 'Others'
export const OS_WINDOWS_10 = 'Windows 10'
export const OS_WINDOWS_2012 = 'Windows 2012'
export const OS_WINDOWS_2016 = 'Windows 2016'
export const OS_WINDOWS_2019 = 'Windows 2019'

export const BILLING_TYPE_SELF = 'self'
export const BILLING_TYPE_PARENT = 'parent'

export const REPORTER_SCHEDULE_WEEKLY = 'Every Week'
export const REPORTER_SCHEDULE_15_DAYS = 'Every 15 Days'
export const REPORTER_SCHEDULE_MONTHLY = 'Every Month'

export const LIST_TOOLBAR_TRACK_DEVICES = 'TrackDevices'
export const LIST_TOOLBAR_TERMINAL = 'Terminal'

export const VERIFY_PASSWORD = 0
export const VERIFY_EMAIL = 1

export const CON_VALUES = 'values'
export const CON_TAGS = 'tags'
export const CON_TOTAL = 'total'
export const CON_CONNECTOR = 'connector'

export const INFO = 'info'
export const ERROR = 'error'
export const WARNING = 'warning'
export const SUCCESS = 'success'
export const NUMBER = 'number'

export const AUDIT = 'audit'
export const EVENT = 'event'

export const PARENT_APP_INST = 'appinst'
export const PARENT_CLUSTER_INST = 'cluster'
export const PARENT_CLOUDLET = 'cloudlet'

export const MEX_PROMETHEUS_APP_NAME = 'MEXPrometheusAppName'
export const NFS_AUTO_PROVISION = 'NFSAutoProvision'

export const PAGE_NETWORKS = 'networks'
export const CONNECTION_UNDEFINED = 'undefined'
export const CONNECT_TO_LOAD_BALANCER = 'Connect to Loadbalancer'
export const CONNECT_TO_CLUSTER_NODES = 'Connect to Cluster Nodes'
export const CONNECT_TO_ALL = 'Connect to All'

export const QOS_NO_PRIORITY = 'No Priority'
export const QOS_LOW_LATENCY = 'Low Latency'
export const QOS_THROUGHPUT_DOWN_S = 'Throughput Down S'
export const QOS_THROUGHPUT_DOWN_M = 'Throughput Down M'
export const QOS_THROUGHPUT_DOWN_L = 'Throughput Down L'

// ---Old Federation
export const PAGE_GUEST_ZONES = 'GuestZones'
export const PAGE_HOST_ZONES = 'HostZones'
export const PAGE_FEDERATION = 'Federation'
export const PAGE_OUTBOUND_FEDERATION = 'Outbound'
export const PAGE_INBOUND_FEDERATION = 'Inbound'
export const PAGE_PARTNER_ZONES = 'Partner Zones'
export const PAGE_SHARED_ZONES = 'Shared Zones'
// ---

// ---New Federation
export const PAGE_FEDERATION_PROVIDER = 'Federation Provider'
export const PAGE_FEDERATION_PROVIDER_SHARED_ZONES = 'ShareZones'
export const PAGE_FEDERATION_PROVIDER_ZONE_BASES = 'ZoneBases'
export const PAGE_FEDERATION_HOST_IMAGES = 'HostImages'
export const PAGE_FEDERATION_HOST_ARTEFACTS = 'HostArtefacts'
export const PAGE_FEDERATION_HOST_APPS = 'HostApps'
export const PAGE_FEDERATION_HOST_APPINSTS = 'HostAppInsts'
export const PAGE_FEDERATION_CONSUMER = 'Federation Consumer'
export const PAGE_FEDERATION_CONSUMER_SHARED_ZONES = 'SharedZones'
export const PAGE_FEDERATION_GUEST_APPS = 'GuestApps'
export const PAGE_FEDERATION_GUEST_IMAGES = 'GuestImages'
export const FEDERATION_ZONE_STATUS_REGISTERED = 'Registered'
// ---

export const PAGE_TRUST_POLICY_EXCEPTION = 'TrustPolicyException'

export const APPROVAL_REQUESTED = 'Approval Requested'
export const APPROVE = 'Approve'
export const REJECT = 'Reject'

export const PROTOCOL_TCP = 'TCP'
export const PROTOCOL_ICMP = 'ICMP'
export const PROTOCOL_UDP = 'UDP'

export const CHART_BULLET = 'Bullet'

export const QUERY_PARAMS = "QUERY_PARAMS"
